(function () {
  'use strict';

  if (window.FuntekLeadContextReady) return;
  window.FuntekLeadContextReady = true;

  var VISITOR_KEY = 'funtek_lead_visitor_v1';
  var SESSION_KEY = 'funtek_lead_session_v1';
  var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  var FIRST_TOUCH_RETENTION_MS = 180 * 24 * 60 * 60 * 1000;
  var MAX_JOURNEY_PAGES = 20;
  var MAX_TEXT_LENGTH = 240;
  var memoryStore = {};
  var currentPageId = createId();
  var activeStartedAt = document.visibilityState === 'visible' ? Date.now() : null;
  var visitor;
  var session;

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'ft-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function safeParse(value) {
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return memoryStore[key] || null;
    }
  }

  function storageSet(key, value) {
    memoryStore[key] = value;
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // The in-memory copy keeps the current page functional when storage is unavailable.
    }
  }

  function cleanText(value, maxLength) {
    return String(value || '')
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength || MAX_TEXT_LENGTH);
  }

  function currentPath() {
    return cleanText(window.location.pathname || '/', 300) || '/';
  }

  function currentTitle() {
    return cleanText(document.title || currentPath(), 140);
  }

  function currentTrackingParams() {
    var params = new URLSearchParams(window.location.search || '');
    return {
      utm_source: cleanText(params.get('utm_source'), 100),
      utm_medium: cleanText(params.get('utm_medium'), 100),
      utm_campaign: cleanText(params.get('utm_campaign'), 160),
      utm_term: cleanText(params.get('utm_term'), 160),
      utm_content: cleanText(params.get('utm_content'), 160),
      gclid: cleanText(params.get('gclid'), 220),
      wbraid: cleanText(params.get('wbraid'), 220),
      gbraid: cleanText(params.get('gbraid'), 220),
      msclkid: cleanText(params.get('msclkid'), 220)
    };
  }

  function hasCampaign(params) {
    return !!(
      params.utm_source || params.utm_medium || params.utm_campaign ||
      params.gclid || params.wbraid || params.gbraid || params.msclkid
    );
  }

  function externalReferrerHost() {
    if (!document.referrer) return '';
    try {
      var referrerUrl = new URL(document.referrer);
      if (referrerUrl.hostname === window.location.hostname) return '';
      return referrerUrl.hostname.replace(/^www\./i, '').toLowerCase();
    } catch (error) {
      return '';
    }
  }

  function organicSource(hostname) {
    if (!hostname) return '';
    if (/(^|\.)google\./i.test(hostname)) return 'google';
    if (/(^|\.)bing\.com$/i.test(hostname)) return 'bing';
    if (/(^|\.)search\.yahoo\.com$/i.test(hostname)) return 'yahoo';
    if (/(^|\.)duckduckgo\.com$/i.test(hostname)) return 'duckduckgo';
    if (/(^|\.)baidu\.com$/i.test(hostname)) return 'baidu';
    if (/(^|\.)yandex\./i.test(hostname)) return 'yandex';
    return '';
  }

  function detectTouch(allowDirect) {
    var params = currentTrackingParams();
    var referrerHost = externalReferrerHost();
    var source = '';
    var medium = '';

    if (params.utm_source) {
      source = params.utm_source;
      medium = params.utm_medium || 'campaign';
    } else if (params.gclid || params.wbraid || params.gbraid) {
      source = 'google';
      medium = 'cpc';
    } else if (params.msclkid) {
      source = 'bing';
      medium = 'cpc';
    } else if (referrerHost) {
      source = organicSource(referrerHost) || referrerHost;
      medium = organicSource(referrerHost) ? 'organic' : 'referral';
    } else if (allowDirect) {
      source = 'direct';
      medium = '(none)';
    } else {
      return null;
    }

    return {
      source: source,
      medium: medium,
      campaign: params.utm_campaign,
      term: params.utm_term,
      content: params.utm_content,
      utmSource: params.utm_source,
      utmMedium: params.utm_medium,
      referrer: referrerHost,
      landing: currentPath(),
      capturedAt: Date.now(),
      clickIds: {
        gclid: params.gclid,
        wbraid: params.wbraid,
        gbraid: params.gbraid,
        msclkid: params.msclkid
      }
    };
  }

  function freshVisitor(now, touch) {
    return {
      createdAt: now,
      lastSeenAt: now,
      visitCount: 0,
      firstTouch: touch
    };
  }

  function freshSession(now, touch) {
    return {
      id: createId(),
      startedAt: now,
      lastActivityAt: now,
      landing: currentPath(),
      firstTouch: touch,
      currentTouch: touch,
      clickIds: touch.clickIds || {},
      pages: [],
      pageCount: 0,
      quoteOpened: false,
      quoteOpenSource: '',
      whatsappClicked: false
    };
  }

  function saveState() {
    session.lastActivityAt = Date.now();
    visitor.lastSeenAt = session.lastActivityAt;
    storageSet(SESSION_KEY, JSON.stringify(session));
    storageSet(VISITOR_KEY, JSON.stringify(visitor));
  }

  function initializeState() {
    var now = Date.now();
    var detectedTouch = detectTouch(true);
    var storedVisitor = safeParse(storageGet(VISITOR_KEY));
    var storedSession = safeParse(storageGet(SESSION_KEY));

    if (
      !storedVisitor || !storedVisitor.firstTouch ||
      now - Number(storedVisitor.firstTouch.capturedAt || storedVisitor.createdAt || 0) > FIRST_TOUCH_RETENTION_MS
    ) {
      storedVisitor = freshVisitor(now, detectedTouch);
    }

    var isNewSession = !storedSession || !storedSession.startedAt ||
      now - Number(storedSession.lastActivityAt || storedSession.startedAt) > SESSION_TIMEOUT_MS;

    if (isNewSession) {
      storedVisitor.visitCount = Number(storedVisitor.visitCount || 0) + 1;
      storedSession = freshSession(now, detectedTouch);
    } else {
      var newTouch = detectTouch(false);
      if (newTouch) {
        storedSession.currentTouch = newTouch;
        storedSession.clickIds = storedSession.clickIds || {};
        Object.keys(newTouch.clickIds || {}).forEach(function (key) {
          if (newTouch.clickIds[key]) storedSession.clickIds[key] = newTouch.clickIds[key];
        });
      }
    }

    visitor = storedVisitor;
    session = storedSession;
    addCurrentPage(now);
    saveState();
  }

  function addCurrentPage(now) {
    var pages = Array.isArray(session.pages) ? session.pages : [];
    pages.push({
      id: currentPageId,
      path: currentPath(),
      title: currentTitle(),
      enteredAt: now,
      activeMs: 0
    });
    if (pages.length > MAX_JOURNEY_PAGES) pages = pages.slice(-MAX_JOURNEY_PAGES);
    session.pages = pages;
    session.pageCount = Number(session.pageCount || 0) + 1;
  }

  function flushActiveTime() {
    if (!activeStartedAt) return;
    var now = Date.now();
    var elapsed = Math.max(0, Math.min(now - activeStartedAt, SESSION_TIMEOUT_MS));
    var pages = session.pages || [];
    for (var i = pages.length - 1; i >= 0; i -= 1) {
      if (pages[i].id === currentPageId) {
        pages[i].activeMs = Number(pages[i].activeMs || 0) + elapsed;
        break;
      }
    }
    activeStartedAt = null;
    saveState();
  }

  function mergeClickIds() {
    var params = currentTrackingParams();
    var keys = ['gclid', 'wbraid', 'gbraid', 'msclkid'];
    session.clickIds = session.clickIds || {};
    keys.forEach(function (key) {
      if (params[key]) session.clickIds[key] = params[key];
    });
  }

  function isWhatsAppLink(link) {
    if (!link) return false;
    var href = String(link.getAttribute('href') || '').toLowerCase();
    return href.indexOf('https://wa.me/') === 0 ||
      href.indexOf('http://wa.me/') === 0 ||
      href.indexOf('https://api.whatsapp.com/') === 0 ||
      href.indexOf('http://api.whatsapp.com/') === 0 ||
      href.indexOf('https://web.whatsapp.com/') === 0 ||
      href.indexOf('http://web.whatsapp.com/') === 0 ||
      href.indexOf('whatsapp://') === 0;
  }

  function quoteOpener(element) {
    if (!element || !element.closest) return null;
    return element.closest(
      '[data-frq-open], [data-fslp-quote-open], [data-quote-open], ' +
      '[aria-controls*="FuntekRfqPanel"], [aria-controls*="QuoteDrawer"]'
    );
  }

  function onDocumentClick(event) {
    var opener = quoteOpener(event.target);
    if (opener) {
      session.quoteOpened = true;
      session.quoteOpenSource = cleanText(
        opener.getAttribute('data-frq-internal-source') ||
        opener.getAttribute('data-source') ||
        opener.id || opener.textContent,
        100
      );
      saveState();
    }

    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (isWhatsAppLink(link)) {
      session.whatsappClicked = true;
      saveState();
    }
  }

  function browserInfo() {
    var ua = navigator.userAgent || '';
    var match;
    if ((match = ua.match(/Edg\/(\d+)/))) return 'Edge ' + match[1];
    if ((match = ua.match(/OPR\/(\d+)/))) return 'Opera ' + match[1];
    if ((match = ua.match(/CriOS\/(\d+)/))) return 'Chrome ' + match[1];
    if ((match = ua.match(/Chrome\/(\d+)/))) return 'Chrome ' + match[1];
    if ((match = ua.match(/FxiOS\/(\d+)/))) return 'Firefox ' + match[1];
    if ((match = ua.match(/Firefox\/(\d+)/))) return 'Firefox ' + match[1];
    if ((match = ua.match(/Version\/(\d+).+Safari/))) return 'Safari ' + match[1];
    return cleanText(navigator.appName || 'Unknown', 80);
  }

  function operatingSystem() {
    var ua = navigator.userAgent || '';
    var match;
    if ((match = ua.match(/Android\s([\d.]+)/))) return 'Android ' + match[1];
    if ((match = ua.match(/(?:iPhone OS|CPU OS)\s([\d_]+)/))) return 'iOS ' + match[1].replace(/_/g, '.');
    if ((match = ua.match(/Windows NT\s([\d.]+)/))) {
      var versions = { '10.0': '10/11', '6.3': '8.1', '6.2': '8', '6.1': '7' };
      return 'Windows ' + (versions[match[1]] || match[1]);
    }
    if ((match = ua.match(/Mac OS X\s([\d_]+)/))) return 'macOS ' + match[1].replace(/_/g, '.');
    if (/Linux/i.test(ua)) return 'Linux';
    return cleanText(navigator.platform || 'Unknown', 80);
  }

  function deviceCategory() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'Tablet';
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'Mobile';
    return 'Desktop';
  }

  function formatSource(touch) {
    if (!touch) return 'direct / (none)';
    var value = (touch.source || 'direct') + ' / ' + (touch.medium || '(none)');
    if (touch.campaign) value += ' · campaign: ' + touch.campaign;
    return value;
  }

  function formatClickIds() {
    var values = [];
    var ids = session.clickIds || {};
    ['gclid', 'wbraid', 'gbraid', 'msclkid'].forEach(function (key) {
      if (ids[key]) values.push(key + '=' + ids[key]);
    });
    return values.length ? values.join(' | ') : 'None';
  }

  function seconds(ms) {
    return Math.max(0, Math.round(Number(ms || 0) / 1000));
  }

  function journeyText() {
    var pages = session.pages || [];
    if (!pages.length) return currentPath() + ' — 0s';
    return pages.map(function (page, index) {
      return (index + 1) + '. ' + (page.title || page.path) + ' [' + page.path + '] — ' + seconds(page.activeMs) + 's';
    }).join('\n');
  }

  function totalActiveSeconds() {
    return (session.pages || []).reduce(function (total, page) {
      return total + seconds(page.activeMs);
    }, 0);
  }

  function isContactForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var formType = form.querySelector('input[name="form_type"][value="contact"]');
    var action = String(form.getAttribute('action') || '');
    return !!formType || /\/contact(?:[#?]|$)/i.test(action);
  }

  function formName(form) {
    var existing = form.querySelector('[name="contact[Form location]"], [name="contact[Form source]"]');
    if (existing && existing.value) return cleanText(existing.value, 120);
    if (form.classList.contains('frq-form')) return 'Project Quote Drawer V2';
    if (form.id) return cleanText(form.id, 120);
    var className = cleanText(form.className, 120);
    return className || 'Shopify contact form';
  }

  function existingValue(form, selectors) {
    var field = form.querySelector(selectors);
    return field ? cleanText(field.value, 500) : '';
  }

  function upsertField(form, label, value, multiline) {
    var name = 'contact[' + label + ']';
    var field = Array.prototype.find.call(form.elements || [], function (element) {
      return element.name === name;
    });
    if (!field) {
      field = document.createElement(multiline ? 'textarea' : 'input');
      if (!multiline) field.type = 'hidden';
      field.name = name;
      field.hidden = true;
      field.setAttribute('aria-hidden', 'true');
      field.tabIndex = -1;
      form.appendChild(field);
    }
    field.value = String(value == null ? '' : value);
  }

  function attachLeadContext(form) {
    flushActiveTime();
    activeStartedAt = document.visibilityState === 'visible' ? Date.now() : null;
    mergeClickIds();

    if (form.classList.contains('frq-form') || /quote|rfq/i.test(form.id || '')) {
      session.quoteOpened = true;
    }

    var firstTouch = visitor.firstTouch || session.firstTouch;
    var currentTouch = session.currentTouch || session.firstTouch;
    var context = existingValue(form, '[data-frq-selection-context], [name="contact[Selection assistant context]"]');
    var openSource = existingValue(form, '[data-frq-open-source], [name="contact[RFQ open source]"]') || session.quoteOpenSource;

    upsertField(form, 'First landing', firstTouch && firstTouch.landing ? firstTouch.landing : session.landing);
    upsertField(form, 'First source', formatSource(firstTouch));
    upsertField(form, 'Current source', formatSource(currentTouch));
    upsertField(form, 'UTM source', currentTouch ? currentTouch.utmSource : '');
    upsertField(form, 'UTM medium', currentTouch ? currentTouch.utmMedium : '');
    upsertField(form, 'UTM campaign', currentTouch ? currentTouch.campaign : '');
    upsertField(form, 'UTM term', currentTouch ? currentTouch.term : '');
    upsertField(form, 'UTM content', currentTouch ? currentTouch.content : '');
    upsertField(form, 'Ad click IDs', formatClickIds(), true);
    upsertField(form, 'Visit journey', journeyText(), true);
    upsertField(form, 'Total active time', totalActiveSeconds() + ' seconds');
    upsertField(form, 'Pages viewed', Number(session.pageCount || (session.pages || []).length));
    upsertField(form, 'Visitor type', Number(visitor.visitCount || 1) > 1 ? 'Returning' : 'New');
    upsertField(form, 'Visit number', Number(visitor.visitCount || 1));
    upsertField(form, 'Device', deviceCategory());
    upsertField(form, 'Browser', browserInfo());
    upsertField(form, 'Operating system', operatingSystem());
    upsertField(form, 'Screen size', window.screen.width + '×' + window.screen.height);
    upsertField(form, 'Viewport size', window.innerWidth + '×' + window.innerHeight);
    upsertField(form, 'Language', navigator.language || 'Unknown');
    upsertField(form, 'Timezone', (Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown'));
    upsertField(form, 'Form name', formName(form));
    upsertField(form, 'Form open source', openSource || 'Direct form view');
    upsertField(form, 'Page context', context || (currentTitle() + ' · ' + currentPath()), true);
    upsertField(form, 'Quote drawer opened', session.quoteOpened ? 'Yes' : 'No');
    upsertField(form, 'WhatsApp clicked', session.whatsappClicked ? 'Yes' : 'No');
    upsertField(form, 'Session started', new Date(session.startedAt).toISOString());
    upsertField(form, 'Submitted at', new Date().toISOString());
    saveState();
  }

  function onSubmit(event) {
    var form = event.target;
    if (!isContactForm(form)) return;
    attachLeadContext(form);
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      flushActiveTime();
    } else if (!activeStartedAt) {
      var now = Date.now();
      if (now - Number(session.lastActivityAt || now) > SESSION_TIMEOUT_MS) {
        visitor.visitCount = Number(visitor.visitCount || 0) + 1;
        session = freshSession(now, detectTouch(true));
        currentPageId = createId();
        addCurrentPage(now);
        saveState();
      }
      activeStartedAt = now;
    }
  }

  initializeState();
  document.addEventListener('click', onDocumentClick, false);
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('visibilitychange', onVisibilityChange, false);
  window.addEventListener('pagehide', flushActiveTime, false);

  window.FuntekLeadContext = {
    version: '1.0.0',
    snapshot: function () {
      flushActiveTime();
      activeStartedAt = document.visibilityState === 'visible' ? Date.now() : null;
      return JSON.parse(JSON.stringify({ visitor: visitor, session: session }));
    },
    enrichForm: function (form) {
      if (isContactForm(form)) attachLeadContext(form);
    }
  };
})();
